import {
  ADMINPOST_CREATE_ACTIONS,
  ADMINPOST_LIST_ACTIONS,
  ADMINPOST_EDIT_ACTIONS,
  ADMINPOST_DELETE_ACTIONS,
} from "../../actionType/adminPost";
import { ADMINPOSTBYID_LIST_ACTIONS } from "../../actionType/admin/adminPost";

const intialState = {
  adminPostCreatData: {},
  isAdminPostCreatLoader: false,
  adminPostList: [],
  isAdminPostListLoader: false,
  adminPostListById: [],
  isAdminPostListByIdLoader: false,
  adminPostDeleteLoader: false,
  portfoliosDeleteData: {},
};

export const adminPostReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case ADMINPOST_CREATE_ACTIONS.ADMINPOST_REQUEST:
      return { ...state, isAdminPostCreatLoader: true };
    case ADMINPOST_CREATE_ACTIONS.ADMINPOST_RESPONSE:
      return {
        ...state,
        adminPostCreatData: payload,
        isAdminPostCreatLoader: false,
      };
    case ADMINPOST_CREATE_ACTIONS.ADMINPOST_ERROR:
      return {
        ...state,
        adminPostCreatData: payload,
        isAdminPostCreatLoader: false,
      };

    // ADMINPOST_LIST_ACTIONS

    case ADMINPOST_LIST_ACTIONS.ADMINPOST_LIST_REQUEST:
      return { ...state, isAdminPostListLoader: true };
    case ADMINPOST_LIST_ACTIONS.ADMINPOST_LIST_RESPONSE:
      return {
        ...state,
        adminPostList: payload,
        isAdminPostListLoader: false,
      };
    case ADMINPOST_LIST_ACTIONS.ADMINPOST_LIST_ERROR:
      return {
        ...state,
        adminPostList: payload,
        isAdminPostListLoader: false,
      };
    // ADMINPOSTBYID_LIST_ACTIONS

    case ADMINPOSTBYID_LIST_ACTIONS.ADMINPOSTBYID_LIST_REQUEST:
      return { ...state, isAdminPostListByIdLoader: true };
    case ADMINPOSTBYID_LIST_ACTIONS.ADMINPOSTBYID_LIST_RESPONSE:
      return {
        ...state,
        adminPostListById: payload,
        isAdminPostListByIdLoader: false,
      };
    case ADMINPOSTBYID_LIST_ACTIONS.ADMINPOSTBYID_LIST_ERROR:
      return {
        ...state,
        adminPostListById: payload,
        isAdminPostListByIdLoader: false,
      };

    // ADMINPOST_EDIT_ACTIONS

    case ADMINPOST_EDIT_ACTIONS.ADMINPOST_EDIT_REQUEST:
      return { ...state, isAdminPostCreatLoader: true };
    case ADMINPOST_EDIT_ACTIONS.ADMINPOST_EDIT_RESPONSE:
      return {
        ...state,
        adminPostCreatData: payload,
        isAdminPostCreatLoader: false,
      };
    case ADMINPOST_EDIT_ACTIONS.ADMINPOST_EDIT_ERROR:
      return {
        ...state,
        adminPostCreatData: payload,
        isAdminPostCreatLoader: false,
      };
    // ADMINPOST_DELETE_ACTIONS

    case ADMINPOST_DELETE_ACTIONS.ADMINPOST_DELETE_REQUEST:
      return { ...state, adminPostDeleteLoader: true };
    case ADMINPOST_DELETE_ACTIONS.ADMINPOST_DELETE_REQUEST:
      return {
        ...state,
        portfoliosDeleteData: payload,
        adminPostDeleteLoader: false,
      };
    case ADMINPOST_DELETE_ACTIONS.ADMINPOST_DELETE_ERROR:
      return {
        ...state,
        portfoliosDeleteData: payload,
        adminPostDeleteLoader: false,
      };
    default:
      return state;
  }
};
